import { render, staticRenderFns } from "./pt-search.vue?vue&type=template&id=44d9a730"
import script from "./pt-search.vue?vue&type=script&lang=js"
export * from "./pt-search.vue?vue&type=script&lang=js"
import style0 from "./pt-search.vue?vue&type=style&index=0&id=44d9a730&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports